import useRoute from '../hooks/useRoute';

// Required - Navigation
function RouteWrapper() {
  useRoute(); // Init Store Route Management
  return null;
}

export default RouteWrapper;
